export default __webpack_public_path__ + "static/media/Romantically.49ff776e.otf";